/**
 * Фильтрует список по подстроке в указанных строковых полях (case-insensitive).
 * Пустой / whitespace-only query возвращает исходный массив.
 */
const filterBySearchQuery = <T>(
  items: T[],
  query: string,
  searchFields: readonly (keyof T)[]
): T[] => {
  if (!items.length) {
    return [];
  }

  const lowerQuery = query.trim().toLowerCase();

  if (!lowerQuery) {
    return items;
  }

  return items.filter((item) =>
    searchFields.some((field) => {
      const value = item[field];

      return (
        typeof value === 'string' && value.toLowerCase().includes(lowerQuery)
      );
    })
  );
};

export default filterBySearchQuery;
